module.exports = __webpack_public_path__ + "static/img/detail_meetthebrowns_02.36dea3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/meet-the-browns-banner-campaign/detail_meetthebrowns_02.jpg
// module id = 260
// module chunks = 2